export default __webpack_public_path__ + "static/blog-03-1170x600-08061757905fe14206dad6fc58f5b5d8.jpg";